module.exports = __webpack_public_path__ + "static/media/icomoon.07d73f20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/fonts/icomoon.svg
// module id = 1449
// module chunks = 1